<template>
	<div>
		<v-tooltip
			right
		>
			<v-btn
				slot="activator"
				:color="color"
				:style="{ left: fabLeftAmount }"
				fab
				dark
				class="fixed-bottom"
				@click="openDialog()"
			>
				<v-icon>{{ icon }}</v-icon>
			</v-btn>
			{{ tooltip }}
		</v-tooltip>
		<v-dialog
			v-model="showDialog"
			max-width="800px"
			persistent
		>
			<v-card class="pt-3">
				<loading :loading="loading" />
				<slot v-if="!loading" name="dialog" />
				<v-container class="pt-0 text-xs-center">
					<v-btn
						flat
						color="error"
						@click="close()"
					>
						Close
					</v-btn>
				</v-container>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
export default {
	props: {
		color: { type: String, default: 'primary' },
		tooltip: { type: String, default: 'tooltip' },
		icon: { type: String, default: 'add' },
		loading: { type: Boolean, default: false },
	},
	data() {
		return {
			showDialog: false,
		};
	},
	computed: {
		fabLeftAmount() {
			if (this.$vuetify.breakpoint.lgAndUp) {
				return '130px';
			}
			return '20px';
		},
	},
	methods: {
		openDialog() {
			this.showDialog = true;
			this.$emit('open');
		},
		close() {
			this.showDialog = false;
		},
	},
};
</script>

<style lang="scss" scoped>
.fixed-bottom {
	position: fixed;
	bottom: 20px;
}
</style>
